export default __webpack_public_path__ + "img/kl_real_talk_2022-03528b4ce70646888c006aec2a318efa.png";